import React from 'react';
import moment from 'moment';
import global from '../../../../common/utility/global';
import { FORMAT_2DECIMALS , GREATER_THAN_ZERO} from '../../../../common/types/regularExpresionType';
import { Table, Empty, Button, Input, Form, Select, DatePicker, Icon } from 'antd';
const { Option } = Select;

export default function FormaPago(props) {
    return (
        <div>
            <Table
                style={{ overflowX: 'auto' }}
                className={'table-cuota'}
                size="small"
                pagination={false}
                dataSource={props.dataSource}
                rowKey={record => record.identifier}
                locale={{
                    emptyText: <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description='Pulse el botón "+ Agregar".'
                    />
                }}
                columns={[
                    {
                        key: 'remove-button',
                        align: 'center',
                        width: '50px',
                        render: (value, row) => (
                            <span>
                                <div className="custom-options">
                                    <Button
                                        type="danger"
                                        icon="delete"
                                        size={"small"}
                                        onClick={() => props.onRemove(value)}
                                    />
                                </div>
                            </span>
                        )
                    },
                    {
                        title: 'Fecha',
                        dataIndex: 'fecha',
                        key: 'fecha',
                        align: 'center',
                        // width: 120,
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrFecha[${row.identifier}]`, {
                                        initialValue: moment(value, 'DD/MM/YYYY'),
                                        rules: [{
                                            required: true,
                                            message: "Formato (dd/mm/yyyy)"
                                        }]
                                    })(
                                        <DatePicker
                                            className="first-input"
                                            placeholder="dd/mm/yyyy"
                                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                            format="DD/MM/YYYY"
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },

                    {
                        title: 'Metodo de Pago',
                        dataIndex: 'idMetodoPago',
                        key: 'idMetodoPago',
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrMetodoPago[${row.identifier}]`, {
                                        initialValue: value ? { key: value } : undefined,
                                        validateTrigger: ['onBlur'],
                                        rules: [{
                                            required: true,
                                            message: 'Requerido'
                                        }]
                                    })(
                                        <Select showSearch labelInValue
                                            placeholder={"Seleccione Tipo Pago"}
                                            optionFilterProp="children"
                                        >
                                            {props.listaMetodoPago.map(item => (
                                            <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                        ))}
                                        </Select>
                                    )}
                                </Form.Item>
                            );
                        }
                    },

                     {
                        title: 'Destino',
                        dataIndex: 'idDestino',
                        className:'hide',
                        key: 'idDestino',
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arridDestino[${row.identifier}]`, {
                                        initialValue: value ? { key: value } : undefined,
                                        validateTrigger: ['onBlur'],
                                        rules: [{
                                            required: false,
                                            message: 'Requerido'
                                        }]
                                    })(
                                        <Select showSearch labelInValue
                                            placeholder={"Seleccione Cuenta"}
                                            optionFilterProp="children"
                                        >
                                            {props.listaCuentaDestino.map(item => (
                                                <Option key={parseInt(item.idCuenta)} value={parseInt(item.idCuenta)}>{item.nombre}</Option>
                                            ))}
                                        </Select>
                                    )}
                                </Form.Item>
                            );
                        }
                    }, 

                    {
                        title: 'Referencia',
                        className:'hide',
                        dataIndex: 'referencia',
                        key: 'referencia',
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrreferencia[${row.identifier}]`, {
                                        initialValue: value,
                                        validateTrigger: ['onBlur'],
                                        rules: [{
                                            required: false,
                                            message: 'Requerido',
                                            whitespace: true
                                        }]
                                    })(
                                        <Input
                                            placeholder="Ingresar Referencia"
                                            autoComplete="off"
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },
     

                    {
                        title: 'Monto de Cuota',
                        dataIndex: 'montoCuota',
                        key: 'montoCuota',
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrMontoCuota[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(2),
                                        rules: [{
                                            required: true,
                                            pattern: new RegExp(FORMAT_2DECIMALS),
                                            message: "Formato (0.00)"
                                        },
                                        {
                                            required: true,
                                            pattern: new RegExp(GREATER_THAN_ZERO),
                                            message: "Monto de Cuota debe ser mayor a 0"
                                        }]
                                    })(
                                        <Input
                                            className="text-right"
                                            onKeyPress={global.onKeyPressDecimals}
                                            placeholder="Ingresar Monto de Cuota"
                                            autoComplete="off"
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    }
               
                ]}
            />
        </div>
    );
}